<template>
  <b-modal ref="supplier-card-modal" @ok="supplierCardModalOk">
    <template v-slot:modal-header="{}">
      <div>{{ $store.state.localization.data.mainPage.azk.suppliers.pageLabel }}</div>
    </template>
    <div style="font-size: 13px">
      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.suppliers.tableColumns.name"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="name"
          :state="isNameValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.suppliers.tableColumns.responsiblePersonName"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="responsiblePersonName"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.suppliers.tableColumns.responsiblePersonPhone"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="responsiblePersonPhone"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.suppliers.tableColumns.codeEdrpou"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="codeEdrpou"
          :state="isCodeEdrpouValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.suppliers.tableColumns.filia"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="filia"
          :state="isFiliaValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.common.created"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="created"
          style="font-size: 13px"
          readonly
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.common.updated"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="updated"
          style="font-size: 13px"
          readonly
        ></b-form-input>
      </b-form-group>
      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.users.tableColumns.userName"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="supplier.executor"
          style="font-size: 13px"
          readonly
        ></b-form-input>
      </b-form-group>
    </div>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="success" style="font-size: 12px" @click="ok()">{{
        $store.state.localization.data.common.table.ok
      }}</b-button>
      <b-button variant="light" style="font-size: 12px" @click="cancel()">{{
        $store.state.localization.data.common.table.cancel
      }}</b-button>
    </template>
  </b-modal>
</template>

<script>

import { utilsService, azkService } from "../../../../services";

export default {
  name: "UpdateSupplierPage",
  props: {
    supplier: Object,
  },
  components: {},
  data() {
    return {
      name: null,
      responsiblePersonName: null,
      responsiblePersonPhone: null,
      codeEdrpou: null,
      filia: null,

      isNameValid: null,
      isCodeEdrpouValid: null,
      isFiliaValid: null,
      created: null,
      updated: null
    };
  },
  methods: {
    async open() {
      this.isNameValid = null;
      this.isCodeEdrpouValid = null;
      this.isFiliaValid = null;

      this.name = this.supplier.name;
      this.responsiblePersonName = this.supplier.responsiblePersonName;
      this.responsiblePersonPhone = this.supplier.responsiblePersonPhone;
      this.codeEdrpou = this.supplier.codeEdrpou;
      this.filia = this.supplier.filia;

      this.created = utilsService.formatDateTime(new Date(this.supplier.created * 1000), utilsService.DATE_TIME_FORMAT);
      this.updated = utilsService.formatDateTime(new Date(this.supplier.updated * 1000), utilsService.DATE_TIME_FORMAT);

      this.$refs["supplier-card-modal"].show();
    },
    validate() {
      let isValid = true;

      if (!this.name) {
        this.isNameValid = false;
        isValid = false;
      } else {
        this.isNameValid = null;
      }

      if (!this.codeEdrpou) {
        this.isCodeEdrpouValid = false;
        isValid = false;
      } else {
        this.isCodeEdrpouValid = null;
      }

      if (!this.filia) {
        this.isFiliaValid = false;
        isValid = false;
      } else {
        this.isFiliaValid = null;
      }

      return isValid;
    },
    async supplierCardModalOk(event) {
      if (!this.validate()) {
        event.preventDefault();
        return;
      }

      this.supplier.name = this.name;
      this.supplier.responsiblePersonName = this.responsiblePersonName;
      this.supplier.responsiblePersonPhone = this.responsiblePersonPhone;
      this.supplier.codeEdrpou = this.codeEdrpou;
      this.supplier.filia = this.filia;
      
      const updateSupplierResponse = await azkService.updateSupplier(this.supplier);

      if (
        updateSupplierResponse.isSuccess &&
        updateSupplierResponse.data &&
        updateSupplierResponse.data.countInsertedRows == 1
      ) {
        this.$emit("supplierUpdatedSuccessEvent", this.supplier);
      } else {
        this.$emit("supplierUpdatedFailEvent");
      }
    },
  },
};
</script>
